/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQueryClient } from "@tanstack/react-query";
import { useFormContext } from "react-hook-form";
import { useSearchParams } from "react-router-dom";

export default function useMethod() {
  const [searchParams, setSearchParams] = useSearchParams();
  const queryClient = useQueryClient();
  const packages = queryClient.getQueryData<any>(["packages"]);

  const form = useFormContext();

  const chosenPackage = packages?.resultList?.find((pkg: any) => pkg.id === form.watch("packageId"));
  const billingPeriod = form.watch("billingPeriod");

  const handleClickMethod = () => {
    form.setValue("paymentTypeId", 2);
    searchParams.set("tab", "payment");
    setSearchParams(searchParams);
  };

  const handleChangePackage = () => {
    searchParams.set("tab", "package");
    setSearchParams(searchParams);
    form.setValue("packageId", null);
  };

  return { packages, chosenPackage, billingPeriod, handleClickMethod, handleChangePackage };
}
